module.exports = __webpack_public_path__ + "img/credento.b89a04d.png";